// extracted by mini-css-extract-plugin
module.exports = {"MenuItem":"MenuItem_MenuItem__enCAl"};